var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlutter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.5294 0L8 39.838L20.235 52.1686L72 0H47.5294ZM47.2539 36.738L26.0888 58.0683L38.37 70.6303L72 36.738H47.2539Z",
    fill: "#47C5FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.37 70.6303L47.6671 80H71.9998L50.5822 58.3225L38.37 70.6303Z",
    fill: "#00569E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9511 58.207L38.1864 45.8762L50.5822 58.3225L38.37 70.6303L25.9511 58.207Z",
    fill: "#00B5F8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.37 70.6303L48.5391 67.2295L49.5492 59.3635L38.37 70.6303Z",
    fill: "url(#paint0_linear_148_110)",
    fillOpacity: 0.8
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_148_110",
    x1: 38.8118,
    y1: 62.4049,
    x2: 46.869,
    y2: 65.2858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlutter);
export default __webpack_public_path__ + "static/media/flutter.252cad0f9e8439f2e6561440034f39f0.svg";
export { ForwardRef as ReactComponent };